import { RichTextStyle } from '@silvertours/common-landingpages-view';

export { RichTextStyle };

export type TextStyleRules = {
  style?: RichTextStyle;
  hasSpacedParagraphs?: boolean;
};

export type HasTextStyleRules = {
  textStyle?: TextStyleRules;
};
